import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Notification } from './components/Notification/Notification';
import { ReactQueryWrapper } from './components/ReactQueryWrapper/ReactQueryWrapper';
import AuthContextProvider from './context/authContext';
import { AppRoutes } from './routes';

const App = () => (
  <ReactQueryWrapper>
    <BrowserRouter>
      <AuthContextProvider>
        <AppRoutes />
      </AuthContextProvider>
    </BrowserRouter>
    <Notification />
  </ReactQueryWrapper>
);

export default App;
